import { apiClient } from '@/api/client';
import { ENDPOINTS } from '@/api/endpoints';

export const removeFromFavorites = async (id: string) => {
  await apiClient.delete(`${ENDPOINTS.FAVORITES}/${id}`);
};
